import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-translated-files',
  standalone: true,
  templateUrl: './translated-files.component.html',
  styleUrl: './translated-files.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslatedFilesComponent {}
